/**
 * 네비게이션
 * Multi R/W mixins
 *
 * @since 2018-11-09
 * @author mk.ko
 */

import { bus, menuPathToInfo } from '~/utils/multirw'
import { newTab } from '~/utils/newWindow' // TAMS

import { createNamespacedHelpers } from 'vuex'
const multirwHelpers = createNamespacedHelpers('common/multirw')

export default {
  computed: {
    ...multirwHelpers.mapGetters([
      'isMultiRWGuard',
      'isLock',
      'lockInfo',
      'isConfirmCheckOut',
      'isExistChkInWork'
    ])
  },
  data () {
    return {
      clickedTargetPath: ''
    }
  },
  mounted () {},
  beforeDestroy () {},
  methods: {
    ...multirwHelpers.mapActions([
      'setConfirmDialog',
      'checkOut'
    ]),
    // 페이지 변경 전 CheckIn 체크
    async movePage (event) {
      try {
        if (typeof event === 'string') {
          this.clickedTargetPath = event || this.homePath || '/'
        } else {
          this.clickedTargetPath = event.target.pathname || this.homePath || '/'
        }
      } catch (e) {
        this.clickedTargetPath = this.homePath || '/'
      }

      const menuInfo = menuPathToInfo(this.$route.path, this.menu) // 현재 페이지 메뉴 정보
      const menuPermission = Boolean(_.get(menuInfo, ['admin_menu_role_type'], 0)) // 쓰기 권한 체크
      const isSupersetURI = _.toLower(this.clickedTargetPath).indexOf('superset') > -1

      if (this.$route.path !== this.clickedTargetPath &&
          this.isMultiRWGuard &&
          menuPermission &&
          !isSupersetURI) {
        this.showCheckOutConfirmDialog()
      } else {
        if (!isSupersetURI) {
          if (this.clickedTargetPath !== this.$route.path) {
            this.$router.push(this.clickedTargetPath)
          }
          return
        }
        // Superset 피처 관련
        const globalAlertDialog = this.$store.state.common.common.components.alertDialog
        try {
          this.$loader.show()
          const res = await this.$axios.$get('/superset/connect', { loading: false, successAlert: false })
          this.$loader.hide()

          if (res.code === 'ok') {
            const url = '/superset'
            // window.open(url, '_blank', 'noopener')
            // TAMS, 구버전 noopener 옵션 미동작에 따른 기능 대체
            newTab(url)
            return
          }
          // error
          if (_.get(res, ['result', 'msg', 'length'], 0) > 0) {
            globalAlertDialog.show(res.result.msg, 'error')
          } else {
            globalAlertDialog.show(this.$t('msg.CanNotUseSuperSetFeature'), 'error')
          }
        } catch (e) {
          this.$loader.hide()
          globalAlertDialog.show(this.$t('msg.CanNotUseSuperSetFeature'), 'error')
        }
      }
    },
    showCheckOutConfirmDialog (isNotCheckInPage = false) {
      // 체크인 여부 확인 (현재 페이지 혹은 타 페이지)
      if (isNotCheckInPage) {
        // this.$alertPopUp.show(this.$t('cmn.msg_abnormalApproach'))
        this.$store.state.common.common.components.alertDialog.show(this.$t('cmn.msg_abnormalApproach'), 'error')
        setTimeout(() => {
          window.location.replace('/')
        }, 1500)
      } else {
        bus.$emit('guard-show', { path: this.clickedTargetPath })
      }
      this.setConfirmDialog(false)
    }
  },
  watch: {
    // MultiRW Check-In 중 페이지 이동 감시용 이벤트
    isConfirmCheckOut (isConfirmCheckOut) {
      if (isConfirmCheckOut) {
        this.$nextTick(() => {
          this.showCheckOutConfirmDialog(true)
        })
      }
    }
  }
}
